<template>
  <div class="text-center">
    <v-bottom-sheet inset>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="mx-2"
          rounded
          dark
          color="nsecondary"
        >
          <v-icon dark>mdi-history</v-icon>
        </v-btn>
      </template>
      <v-card style="min-height: 50vh;">
        <v-row>
          <v-col cols="12" md="6" class="pa-4">
            <v-alert type="error" v-if="error">{{ error }}</v-alert>
            <v-card-title>Historia</v-card-title>
            <v-card-subtitle>
              Palaa menneisyyteen ja valitse päivä, jonka ruokalistaa haluat
              tarkastella.
            </v-card-subtitle>
            <v-card-text>
              <v-btn
                v-if="results.length === 0"
                @click="findFoodForDate"
                :loading="loading"
                rounded
                dark
                color="nsecondary"
              >
                <v-icon left>mdi-magnify</v-icon> Hae
              </v-btn>
              <v-btn
                v-else
                @click="results = []"
                rounded
                dark
                color="nsecondary"
              >
                Valitse toinen päivä
              </v-btn>
              <v-img
                v-if="easteregg"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Noaa-walrus22.jpg/1200px-Noaa-walrus22.jpg"
              ></v-img>
            </v-card-text>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="pt-8 px-4"
            style="box-sizing: border-box;"
          >
            <v-progress-circular
              v-if="loading"
              size="70"
              width="7"
              indeterminate
              color="nsecondary"
              class="mx-auto"
            />
            <template v-else>
              <v-date-picker
                v-if="results.length === 0"
                v-model="date"
                locale="fi-fi"
                :first-day-of-week="1"
                color="nsecondary"
                header-color="primary"
                full-width
              />
              <v-col v-else v-for="food in renresults" :key="food.id">
                <FoodCard :food="food" />
              </v-col>
            </template>
          </v-col>
        </v-row>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import gvk from "@/genuinevendor-sdk";
import FoodCard from "@/components/FoodCard";

export default {
  data() {
    return {
      date: new Date().toISOString().split("T")[0],
      results: [],
      loading: false,
      error: null
    };
  },
  computed: {
    renresults() {
      let cache = [...this.results];
      for (let i = 0; i < cache.length; i++) {
        const item = cache[i];
        item.humandate = gvk._toHumanDate(item.date);
      }
      return cache;
    },
    easteregg() {
      return (
        !!this.date &&
        this.date.split("-")[1] == "02" &&
        this.date.split("-")[2] == "18"
      );
    }
  },
  methods: {
    findFoodForDate() {
      this.loading = true;
      this.error = null;
      const _apibase = "https://apiv4.kiuruvesi.net/";
      console.log(this.$store.state);
      const _list = this.$store.state.listconfig.list;
      fetch(`${_apibase}list${_list}/history/${this.date}?key=rNKuNrc6H9NtuQEh`)
        .then(res => res.json())
        .then(res => {
          console.log(res);
          if (Array.isArray(res) && res.length > 0) {
            this.results = [...res];
          } else {
            this.error = "Ei hakutuloksia valitulle päivälle :(";
          }
        })
        .catch(e => {
          console.error(e);
          this.error = e;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {
    FoodCard
  }
};
</script>
